var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789",
    transform: "translate(-282 -14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2445",
    "data-name": "Rectangle 2445",
    width: 30,
    height: 30,
    transform: "translate(282 14)",
    fill: "#2c4e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close",
    "data-name": "Icon ionic-md-close",
    d: "M25.523,9.323l-1.8-1.8-7.2,7.2-7.2-7.2-1.8,1.8,7.2,7.2-7.2,7.2,1.8,1.8,7.2-7.2,7.2,7.2,1.8-1.8-7.2-7.2Z",
    transform: "translate(280.477 12.477)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleCloseButton);
export default __webpack_public_path__ + "static/media/toggleCloseButton.633f833912fecc8664a9cd2ce4e3e896.svg";
export { ForwardRef as ReactComponent };